angular.module('homebot.directives')

.directive('rentalPotentialChart', ['$timeout', function($timeout){
  return {
    restrict: 'E',
    controllerAs: 'rentalPotentialChartCtrl',
    bindToController: {
      rentalPotential: '=',
      chartType: '@',
      percentage: '@'
    },
    scope: {},
    template: `
      <div class="chart-container chart-container--bar-chart">
        <svg class="bar-chart"></svg>
      </div>
      `,

    controller: function(){
      let ctrl = this;

      ctrl.update = function(){
        if(!ctrl.chart) return;

        let data;

        data = AirDnaChartSerializer[ctrl.chartType](ctrl.rentalPotential, parseFloat(ctrl.percentage));

        ctrl.chart.update(data);
      };

      $timeout(() => {
        ctrl.chart = new BarChart(ctrl.el);
        ctrl.update();
      });
    },

    link: function(scope, el, attrs, ctrl){
      ctrl.el = el.find('svg')[0];

      el.on('$destroy', () => {
        if(ctrl.chart)
          ctrl.chart.destroy();
      });

      scope.$watch('rentalPotentialChartCtrl.chartType', function(newVal, oldVal){
        if(newVal)
          ctrl.update();
      });

      scope.$watch('rentalPotentialChartCtrl.percentage', function(newVal, oldVal){
        if(newVal)
          ctrl.update();
      });
    },
  }
}]);
